// Purpose: Share the default-off online registration setting across event administration pages.
// Dependencies: React; callers own persistence and supply the event slug.
// Behavior: Public submissions always require manager approval before voting.
import React from "react";

export default function OnlineEntryControl({ enabled, onChange, slug, disabled = false }) {
  const path = slug ? `/${encodeURIComponent(slug)}/public_entry` : "";
  return (
    <div className="mt-3">
      <div className="form-check form-switch">
        <input id="allow-online-entries" className="form-check-input" type="checkbox" role="switch"
          checked={enabled === true} disabled={disabled} onChange={(event) => onChange(event.target.checked)} />
        <label className="form-check-label" htmlFor="allow-online-entries">Allow Online Event Entries</label>
      </div>
      <div className="form-text">Off by default. Save changes to apply. Online entries require manager approval before voting.</div>
      {enabled === true && path && (
        <div className="mt-2 text-break">Public submission URL: <a href={path} target="_blank" rel="noopener noreferrer">{window.location.origin}{path}</a></div>
      )}
    </div>
  );
}
